import { render } from "./Card.vue?vue&type=template&id=b8f8dcde"
import script from "./Card.vue?vue&type=script&lang=js"
export * from "./Card.vue?vue&type=script&lang=js"
script.render = render

export default script